import React, { FC, useContext } from "react";

import { DiscountProgressBarContext } from "../../context";
import { BreakpointProps } from "../types";

import { LockedBreakpoint2 } from "./LockedBreakpoint2";
import { LockedBreakpoint3 } from "./LockedBreakpoint3";
import { LockedBreakpoint4 } from "./LockedBreakpoint4";

export const LockedBreakpointBuilder: FC<BreakpointProps> = (props) => {
  const { theme } = useContext(DiscountProgressBarContext);

  switch (theme.breakpoint.locked) {
    case "lockedBreakpoint2":
      return <LockedBreakpoint2 />;
    case "lockedBreakpoint3":
      return <LockedBreakpoint3 />;
    case "lockedBreakpoint4":
      return <LockedBreakpoint4 />;
    default:
      return null;
  }
};
